import {
  AUTO_EXECUTE_WORKFLOW,
  MIN_SOURCE_CONFIDENCE,
  MIN_WORKFLOW_CONFIDENCE,
  PICK_THE_LANGUAGE,
  AUTO_LANGUAGE_DETECTION,
  WORKFLOWS_ENABLED,
  WORKFLOW_MATCH_CONFIDENCE
} from "../../constants/chat";
import { DEFAULT_FEEDBACK_CONFIG } from "../../constants/defaults";
import { WIDGET_NARROW_EVENT } from "../../constants/events";

function parseNumber(num, defaultNum, parser = parseFloat) {
  num = parser(num);
  return Number.isNaN(num)
    ? defaultNum
    : num
};

export function parseCustomizations(data) {
  const customizations = data?.ftAssistCustomizations;
  const workflowConfig = customizations?.workflowConfig ?? {};
  const responseConfig = customizations?.responseConfig ?? {};
  const feedbackFormConfig = customizations?.feedbackFormConfig ?? {};
  const kbSystem = customizations?.kbSystem ?? {};

  // refer to ../../constants/defaults for details on each property
  return {
    font: customizations?.font,
    theme: customizations?.theme,

    navbarConfig: customizations?.navbarConfig,
    chatConfig: customizations?.chatConfig,
    launchButtonConfig: customizations?.launchButtonConfig ?? {},
    altMobileLaunchButtonConfig: customizations?.altMobileLaunchButtonConfig ?? {},
    minimizedLaunchButtonConfig: customizations?.minimizedLaunchButtonConfig ?? {},

    conversationBanner: {
      config: customizations?.conversationBanner?.config,
      content: customizations?.conversationBanner?.content
    },
    timestampBanner: {
      config: customizations?.timestampBanner?.config,
      content: customizations?.timestampBanner?.content
    },

    validOrigins: customizations?.validOrigins ?? [],

    autoExpand: customizations?.autoExpand ?? true,
    defaultView: customizations?.defaultView ?? WIDGET_NARROW_EVENT,
    disableAutoTicketSubmission: customizations?.disableAutoTicketSubmission  ?? false,
    noTicketAfterHandoffFailure: customizations?.noTicketAfterHandoffFailure ?? false,

    enableKbSearch: customizations?.enableKbSearch ?? false,
    kbSystem: {
      name: kbSystem?.name,
      baseUrl: kbSystem?.baseUrl
    },

    workflowTriggers: customizations?.workflowTriggers ?? {},

    textToSpeechConfig: {
      chat: customizations?.textToSpeechConfig?.chat
    },
    voiceChatConfig: {
      enabled: customizations?.voiceChatConfig?.enabled ?? false
    },

    responseConfig: {
      sourceConfidenceThreshold: parseNumber(
        responseConfig?.sourceConfidenceThreshold,
        MIN_SOURCE_CONFIDENCE
      )
    },
    workflowConfig: {
      enableWorkflows: workflowConfig?.enableWorkflows ?? WORKFLOWS_ENABLED,
      autoExecution: workflowConfig?.autoExecution ?? AUTO_EXECUTE_WORKFLOW,
      minConfidenceThreshold: parseNumber(
        workflowConfig?.minConfidenceThreshold,
        MIN_WORKFLOW_CONFIDENCE
      ),
      highConfidenceThreshold: parseNumber(
        workflowConfig?.highConfidenceThreshold,
        WORKFLOW_MATCH_CONFIDENCE
      ),
      forms: {
        showHeader: workflowConfig?.forms?.showHeader ?? true,
        showTitle: workflowConfig?.forms?.showTitle ?? true,
        showIcon: workflowConfig?.forms?.showIcon ?? true,
        autoPopulate: workflowConfig?.forms?.autoPopulate ?? false,
        fields: workflowConfig?.forms?.fields ?? {}
      }
    },

    localizationConfig: {
      default: customizations?.localizationConfig?.default ?? "",
      initial: customizations?.localizationConfig?.initial ?? AUTO_LANGUAGE_DETECTION,
      supported: {
        ...customizations?.localizationConfig?.supported,
        [PICK_THE_LANGUAGE]: capitalizeString(PICK_THE_LANGUAGE),
        [AUTO_LANGUAGE_DETECTION]: capitalizeString(AUTO_LANGUAGE_DETECTION)
      }
    },

    feedbackFormConfig: {
      enableFeedbackForms: feedbackFormConfig?.enableFeedbackForms ?? DEFAULT_FEEDBACK_CONFIG.enableFeedbackForms,
      header: feedbackFormConfig?.header ?? DEFAULT_FEEDBACK_CONFIG.header,
      title: feedbackFormConfig?.title ?? DEFAULT_FEEDBACK_CONFIG.title,
      rating: feedbackFormConfig?.rating ?? DEFAULT_FEEDBACK_CONFIG.rating,
      thankYouMessage: feedbackFormConfig?.thankYouMessage ?? DEFAULT_FEEDBACK_CONFIG.thankYouMessage,
      fields: [
        ...(feedbackFormConfig?.fields ?? DEFAULT_FEEDBACK_CONFIG.fields),
      ]
    },

    tooltips: customizations?.tooltips ?? {},
    dangerouslyAllowPersonas: customizations?.dangerouslyAllowPersonas ?? false,
    autoLoadArticlesForSingleTopic : customizations?.autoLoadArticlesForSingleTopic ?? false,
  };
}

function capitalizeString(s) {
  return `${s[0].toUpperCase()}${s.slice(1)}`;
}
